import { render, staticRenderFns } from "./youguan.vue?vue&type=template&id=79b2c058&scoped=true"
import script from "./youguan.vue?vue&type=script&lang=js"
export * from "./youguan.vue?vue&type=script&lang=js"
import style0 from "./youguan.vue?vue&type=style&index=0&id=79b2c058&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79b2c058",
  null
  
)

export default component.exports